export class RoleRequest {
    roleAndContextMap: Map<string, string>;
    roleAndContext: any;


    constructor(role: string, context: string) {
        this.roleAndContext = {};
        this.roleAndContext[role] = context;
    }

    /**
     * setRoleAndContextMap
     */
    public setRoleAndContextMap(role: string, context: string) {
        if (this.roleAndContext === undefined || this.roleAndContext === null) {
            return new RoleRequest(role, context);
        } else {
            this.roleAndContext[role] = context;
        }
        return this.roleAndContext;
    }
}

export class RoleResponse {
    roleMap: Map<string, boolean>

    /**
     * mapResponse
    */
    public mapResponse(data: any) {
        if (this.roleMap === undefined || this.roleMap === null) {
            this.roleMap = new Map();
        }
        this.roleMap = data['roleMap'];
        return this.roleMap;
    }
    
    public getRoleMap(role: string) {
        if (this.roleMap === undefined || this.roleMap === null) {
            return false;
        }
        return this.roleMap[role];
    }
}




// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/role-assignment-map.ts